// React import not needed with React 19+ JSX transform
import { Input } from "@/components/ui/input";
import type { FieldConfig } from "../types";

interface EmailFieldProps<T> {
  field: FieldConfig<T>;
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  disabled?: boolean;
  id: string;
  placeholder?: string;
  "aria-describedby"?: string;
}

export function EmailField<T>({
  field,
  value,
  onChange,
  onBlur,
  disabled,
  id,
  placeholder,
  "aria-describedby": ariaDescribedBy,
}: EmailFieldProps<T>) {
  return (
    <Input
      id={id}
      type="email"
      autoComplete="email"
      placeholder={placeholder}
      disabled={disabled}
      aria-describedby={ariaDescribedBy}
      aria-required={field.required || undefined}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
    />
  );
}
